import classNames from 'classnames';
import { DoubleImageElementNewSchema } from '../../content/schema/pageElements.val';
import HotspotImage from './HotspotImage';
import { Image } from '@valbuild/next';

interface Props {
  images: [Image, Image];
  text?: string;
  centered: boolean;
  layout: DoubleImageElementNewSchema['layout'];
}

const DoubleImageElementNew: React.FC<Props> = ({
  images,
  text,
  centered,
  layout,
}) => {
  const wrapperCass = classNames(
    'w-full flex flex-col tablet:flex-row laptop:flex-row gap-24',
    {
      'items-center': centered,
    }
  );

  const [aspectStyleFirst, aspectStyleSecond] =
    layout == 'square-tall'
      ? ['aspect-square', 'aspect-[684/1105]']
      : ['aspect-[684/1105]', 'aspect-square'];

  const textElement = !!text && (
    <p className="text-lg tablet:text-xl">{text}</p>
  );

  return (
    <div className={wrapperCass}>
      <div className="flex-1 w-full flex flex-col gap-24">
        <div className={`w-full relative ${aspectStyleFirst}`}>
          <HotspotImage image={images[0]} />
        </div>
        {layout === 'square-tall' && textElement}
      </div>

      <div className="flex-1 w-full flex flex-col gap-24">
        <div className={`w-full relative ${aspectStyleSecond}`}>
          <HotspotImage image={images[1]} />
        </div>
        {layout === 'tall-square' && textElement}
      </div>
    </div>
  );
};

export default DoubleImageElementNew;
